<template>
  <v-sheet class="mx-auto" max-width="2000">
    <v-card class="mx-auto" elevation="0"
            title="Healthcare resource utilization"
            subtitle="Follow-up year 1 is within 0-12 months from index date, year 2 is within 13-24 months, etc. Total number of patients in care is also shown.">
      <v-row align="center" no-gutters>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationInPatientCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationInPatientCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationInPatientCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationInPatientCareVisitsByIcdChart' + healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular v-else-if="isLoadingHealthcareResourceUtilizationInPatientCareVisitsByIcd"
                                     color="primary"
                                     indeterminate></v-progress-circular>
                <v-alert v-else
                         type="info"
                         variant="tonal"
                         density="comfortable"
                         class="ma-4 text-left">
                  {{ healthcareResourceUtilizationNoDataMessage }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-in-patient-care-days-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationInPatientCareDaysByIcdChartReady"
                        :data="healthcareResourceUtilizationInPatientCareDaysByIcdChartData"
                        :options="healthcareResourceUtilizationInPatientCareDaysByIcdChartOptions"
                        :key="'healthcareResourceUtilizationInPatientCareDayssByIcdChart' + healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationInPatientCareDaysByIcdChartData.length !== 0"/>
                <v-progress-circular v-else-if="isLoadingHealthcareResourceUtilizationInPatientCareDaysByIcd"
                                     color="primary"
                                     indeterminate></v-progress-circular>
                <v-alert v-else
                         type="info"
                         variant="tonal"
                         density="comfortable"
                         class="ma-4 text-left">
                  {{ healthcareResourceUtilizationNoDataMessage }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-in-patient-care-days-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-in-patient-care-days-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-out-patient-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationOutPatientCareVisitsByIcdChart' + healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular v-else-if="isLoadingHealthcareResourceUtilizationOutPatientCareVisitsByIcd"
                                     color="primary"
                                     indeterminate></v-progress-circular>
                <v-alert v-else
                         type="info"
                         variant="tonal"
                         density="comfortable"
                         class="ma-4 text-left">
                  {{ healthcareResourceUtilizationNoDataMessage }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-out-patient-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-out-patient-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="6" xl="6" xxl="6">
          <v-card class="mx-auto" min-height="800" elevation="0" title=""
                  ref="healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart">
            <v-row no-gutters>
              <v-col>
                <GChart type="ColumnChart"
                        @ready="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartReady"
                        :data="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData"
                        :options="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartOptions"
                        :key="'healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChart' + healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex"
                        v-if="healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData.length !== 0"/>
                <v-progress-circular v-else-if="isLoadingHealthcareResourceUtilizationAllSpecialistCareVisitsByIcd"
                                     color="primary"
                                     indeterminate></v-progress-circular>
                <v-alert v-else
                         type="info"
                         variant="tonal"
                         density="comfortable"
                         class="ma-4 text-left">
                  {{ healthcareResourceUtilizationNoDataMessage }}
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart'].$el"
                              :document-title="icd + '-' + 'healthcare-resource-utilization-all-specialist-care-visits-by-icd-chart'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" lg="12" xl="12" xxl="12">
          <v-card class="mx-auto" elevation="0"
                  ref="icd-legend">
            <v-row no-gutters>
              <v-col>
                <v-data-table :headers="icdLegendHeaders"
                              :items="icdLegend"
                              density="compact"
                              :fixed-header="true"
                              :items-per-page="0"
                              class="no-row-borders allow-line-breaks striped-table">
                  <template #bottom></template>
                  <template v-slot:no-data>
                    <v-progress-circular v-if="isLoadingIcdLegend" color="primary" indeterminate></v-progress-circular>
                    <span v-else>No data available</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="text-right">
                <vue-to-print :content="() => this.$refs['icd-legend'].$el"
                              :document-title="icd + '-' + 'icd-legend'"
                              remove-after-print>
                  <template v-slot:trigger>
                    <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
                  </template>
                </vue-to-print>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import {GChart} from 'vue-google-charts'
import axios from "axios";
import { VueToPrint } from "vue-to-print";

export default defineComponent({
  name: 'NeurologicalDiseaseTreatmentPatternInterventions',
  props: {
    icd: String,
    visible: Boolean
  },
  components: {
    GChart,
    VueToPrint
  },
  computed: {
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Inpatient care visits by disease classification (primary/secondary)',
          'Number of visits');
    },
    healthcareResourceUtilizationInPatientCareDaysByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Number of days with overnight inpatient care by disease classification (primary/secondary)',
          'Number of days');
    },
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('Outpatient care visits by disease classification (primary/secondary)',
          'Number of visits');
    },
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartOptions() {
      return this.healthcareResourceUtilizationByIcdChartOptions('All specialist care visits by disease classification (primary/secondary)',
          'Number of visits');
    }
  },
  data: () => ({
    isLoadingIcdLegend: true,
    isLoadingHealthcareResourceUtilizationInPatientCareVisitsByIcd: true,
    isLoadingHealthcareResourceUtilizationInPatientCareDaysByIcd: true,
    isLoadingHealthcareResourceUtilizationOutPatientCareVisitsByIcd: true,
    isLoadingHealthcareResourceUtilizationAllSpecialistCareVisitsByIcd: true,
    healthcareResourceUtilizationNoDataMessage: 'No healthcare resource utilization (TABLE4) data was delivered for this dataset.',
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartData: [],
    healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationInPatientCareDaysByIcdChartData: [],
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData: [],
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex: 0,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries: undefined,
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData: [],
    icdLegendHeaders: [
      {
        title: 'Legend',
        align: 'start',
        key: 'icd',
        sortable: false
      },
      {
        title: '',
        align: 'start',
        key: 'icd_description',
        sortable: false
      }
    ],
    icdLegend: []
  }),
  watch: {
    healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries() {
      this.isLoadingHealthcareResourceUtilizationInPatientCareVisitsByIcd = true
      this.loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData = response.data
      }).finally(() => {
        this.isLoadingHealthcareResourceUtilizationInPatientCareVisitsByIcd = false
      })
    },
    healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries() {
      this.isLoadingHealthcareResourceUtilizationInPatientCareDaysByIcd = true
      this.loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData = response.data
      }).finally(() => {
        this.isLoadingHealthcareResourceUtilizationInPatientCareDaysByIcd = false
      })
    },
    healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries() {
      this.isLoadingHealthcareResourceUtilizationOutPatientCareVisitsByIcd = true
      this.loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData = response.data
      }).finally(() => {
        this.isLoadingHealthcareResourceUtilizationOutPatientCareVisitsByIcd = false
      })
    },
    healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries() {
      this.isLoadingHealthcareResourceUtilizationAllSpecialistCareVisitsByIcd = true
      this.loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries).then((response) => {
        this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData = response.data
      }).finally(() => {
        this.isLoadingHealthcareResourceUtilizationAllSpecialistCareVisitsByIcd = false
      })
    }
  },
  methods: {
    forceRerender() {
      this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationInPatientCareDaysByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartKeyIndex += 1;
      this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartKeyIndex += 1;
    },
    healthcareResourceUtilizationByIcdChartOptions(title, vAxis0Title) {
      return {
        backgroundColor: {
          fill: '#364c5b'
        },
        title: title,
        titlePosition: 'out',
        titleTextStyle: {
          color: '#ffffff',
          bold: false
        },
        height: 800,
        colors: ['#fb9a99', '#a6cee3', '#b2df8a', '#fdbf6f', '#cab2d6', '#ffff99', '#1f78b4', '#33a02c', '#bdbdc7'],
        legend: {
          position: 'top',
          alignment: 'end',
          maxLines: 5,
          textStyle: {
            color: '#c0c0c0',
            fontSize: 12
          },
          scrollArrows: {
            activeColor: '#f0f0f0',
            inactiveColor: 'c0c0c0'
          },
          pagingTextStyle: {
            color: '#f0f0f0'
          }
        },
        isStacked: true,
        series: {
          0: {
            targetAxisIndex: 1,
            type: 'line',
            pointShape: 'diamond',
            pointSize: 10
          },
          1: {
            targetAxisIndex: 0
          }
        },
        hAxis: {
          title: 'Follow-up year',
          titleTextStyle: {
            color: '#f0f0f0',
            italic: false
          },
          gridlines: {
            count: 0
          },
          minorGridlines: {
            count: 0
          },
          textStyle: {
            color: '#ffffff',
            fontSize: 12
          },
          minTextSpacing: 1
        },
        vAxes: {
          0: {
            title: vAxis0Title,
            titleTextStyle: {
              color: '#f0f0f0',
              italic: false
            },
            gridlines: {
              count: 0
            },
            minorGridlines: {
              count: 0
            },
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            }
          },
          1: {
            title: 'Number of patients (N)',
            titleTextStyle: {
              color: '#f0f0f0',
              italic: false
            },
            gridlines: {
              color: '#364c5b',
              count: 0
            },
            minorGridlines: {
              color: '#364c5b',
              count: 0
            },
            textStyle: {
              color: '#ffffff',
              fontSize: 12
            }
          }
        },
        intervals: {
          'style': 'boxes',
          'boxWidth': 1,
          'lineWidth': 0,
          'fillOpacity': 0.2
        },
        tooltip: {
          isHtml: true
        },
        annotations: {
          textStyle: {
            fontSize: 12,
            color: '#808080',
            auraColor: 'none'
          }
        },
        animation: {
          startup: true,
          duration: 500,
          easing: 'out'
        }
      }
    },
    async loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(diagnosisGroup) {
      return axios.get('neurological-disease/healthcare-in-patient-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(diagnosisGroup) {
      return axios.get('neurological-disease/healthcare-in-patient-care-days-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(diagnosisGroup) {
      return axios.get('neurological-disease/healthcare-out-patient-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(diagnosisGroup) {
      return axios.get('neurological-disease/healthcare-all-specialist-care-visits-by-icd-resource-utilization',
          {
            headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
            params: {
              icd: this.icd,
              diagnosis_group: diagnosisGroup
            }
          });
    },
    async loadIcdLegend() {
      return axios.get('neurological-disease/icd-legend', {
        headers: {Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}`},
        params: {
          icd: this.icd,
        }
      });
    },
    async healthcareResourceUtilizationInPatientCareVisitsByIcdChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        if (selectedItem.column > 1) {
          setSeriesChartSelection(selectedItem.column)
        }
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    },
    async healthcareResourceUtilizationInPatientCareDaysByIcdChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationInPatientCareDaysByIcdChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        if (selectedItem.column > 1) {
          setSeriesChartSelection(selectedItem.column)
        }
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    },
    async healthcareResourceUtilizationOutPatientCareVisitsByIcdChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        if (selectedItem.column > 1) {
          setSeriesChartSelection(selectedItem.column)
        }
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    },
    async healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartReady(chart, google) {
      const setSeriesChartSelection = (selectedColumn) => {
        let selectedSeries = this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData[0][selectedColumn]
        if (this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries === selectedSeries) {
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries = undefined
        } else {
          this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries = selectedSeries
        }
      }

      const resetSeriesChartSelection = () => {
        this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartSelectedSeries = undefined
      }

      const seriesSelectHandler = function () {
        const selection = chart.getSelection()
        if (selection.length === 0) {
          resetSeriesChartSelection()
          return
        }
        const selectedItem = selection[0];
        if (selectedItem.column > 1) {
          setSeriesChartSelection(selectedItem.column)
        }
      }

      google.visualization.events.addListener(chart, 'select', seriesSelectHandler);
    }
  },
  async mounted() {
    await Promise.all([
      this.loadHealthcareResourceUtilizationInPatientCareVisitsByIcdData(),
      this.loadHealthcareResourceUtilizationInPatientCareDaysByIcdData(),
      this.loadHealthcareResourceUtilizationOutPatientCareVisitsByIcdData(),
      this.loadHealthcareResourceUtilizationAllSpecialistCareVisitsByIcdData(),
      this.loadIcdLegend()
    ]).then(responses => {
      this.healthcareResourceUtilizationInPatientCareVisitsByIcdChartData = responses[0].data;
      this.healthcareResourceUtilizationInPatientCareDaysByIcdChartData = responses[1].data;
      this.healthcareResourceUtilizationOutPatientCareVisitsByIcdChartData = responses[2].data;
      this.healthcareResourceUtilizationAllSpecialistCareVisitsByIcdChartData = responses[3].data;
      this.icdLegend = responses[4].data
    }).finally(() => {
      this.isLoadingIcdLegend = false
      this.isLoadingHealthcareResourceUtilizationInPatientCareVisitsByIcd = false
      this.isLoadingHealthcareResourceUtilizationInPatientCareDaysByIcd = false
      this.isLoadingHealthcareResourceUtilizationOutPatientCareVisitsByIcd = false
      this.isLoadingHealthcareResourceUtilizationAllSpecialistCareVisitsByIcd = false
    })
  },
  updated() {
    if (this.visible) {
      this.forceRerender()
    }
  }
});
</script>

<style scoped>
.no-row-borders :deep(.v-data-table__tr) {
  border-bottom: none !important;
  box-shadow: none !important;
}

.no-row-borders :deep(.v-data-table__td) {
  border-bottom: none !important;
  box-shadow: none !important;
}

.no-row-borders :deep(.v-data-table__th) {
  border-bottom: none !important;
}

.allow-line-breaks :deep(.v-data-table__td) {
  white-space: pre-line;
}

.striped-table :deep(tbody tr:nth-child(odd)) {
  background-color: rgba(0, 0, 0, .10);
}

@media print {
  .mx-auto {
    zoom: 50%;
  }
}
</style>
